import React from 'react';
import { XIcon } from 'lucide-react';
import { FeedLinkDto } from '@/api/feed';
import Typography from '@/components/primitives/typography';
import styles from './styles.module.scss';

interface LinkListProps {
  links: FeedLinkDto[];
  onDeleteLink: (index: number) => void;
}

/**
 * Component for displaying a list of links with delete functionality
 */
const LinkList: React.FC<LinkListProps> = ({ links, onDeleteLink }) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {links.map((link, index) => (
        <div key={index} className={styles.linkItem}>
          <Typography className={styles.linkText}>{link.account?.name || link.place?.name}</Typography>
          <div className={styles.close} onClick={() => onDeleteLink(index)}>
            <XIcon size={16} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LinkList;